import React from 'react';
import { get } from 'lodash';
import { FieldArray, useFormikContext } from 'formik';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';

import ListResource from '../../lists/ListResource.jsx';
import { isPermitted } from '../../layout/Nav.jsx';
import FieldArrayCards from '../FieldArrayCards.jsx';

const FieldsProductsList = ({ consignment = false, disabled = false, order }) => {
  const api = '/api/core/stocks';
  const path = (string = '', i) => (consignment ? `items.${i}.item.${string}` : `items.${i}.${string}`);
  const { values, status } = useFormikContext();
  const arr = get(values, 'items') || [];

  return (
    <>
      <FieldArray name="items">
        {(helper) => (
          <>
            <div className="row">
              <div className="col">Click stock to add product</div>
            </div>
            <div className="row">
              <div className="col">
                {isPermitted('stocks') && (
                  <ListResource
                    {...{
                      searchable: true,
                      api,
                      sort: { itemCode: 1 },
                      filter: {
                        status: 'Active',
                      },
                      actions: {
                        create: false,
                        remove: false,
                      },
                      onRowClick: (row) => {
                        const included = arr.map((r) => `${r.itemCode} - ${r.serialNo}`);
                        const item = `${row.itemCode} - ${row.serialNo}`;

                        if (status?.disabled || disabled) return null;

                        if (consignment && !included.includes(item)) {
                          return helper.push({
                            item: row,
                            payment: false,
                            complete: false,
                            remarks: '',
                          });
                        }
                        if (!included.includes(item)) {
                          return helper.push(row);
                        }
                        return null;
                      },
                      cols: [
                        {
                          key: 'itemCode',
                          sortable: true,
                          children: 'Item Code',
                        },
                        {
                          key: 'serialNo',
                          sortable: true,
                          children: 'Serial No',
                        },
                        {
                          key: order?.isTradePrice ? 'prices.tradePrice' : 'prices.retailPrice',
                          sortable: true,
                          children: 'Price',
                        },
                      ],
                    }}
                  />
                )}
              </div>
              <div className="col">
                <FieldArrayCards name="items" disabled={status?.disabled || disabled}>
                  {(s, i) => (
                    <>
                      {consignment && (
                        <div className="row">
                          <div className="col">
                            <div className="form-group">
                              <label>Complete</label>
                              <FormCheckGroup
                                name={`items.${i}.complete`}
                                type="checkbox"
                                label=""
                                asSwitch
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col">
                          <FormGroup
                            name={path('itemCode', i)}
                            label="Item Code"
                            disabled
                          />
                        </div>
                        <div className="col">
                          <FormGroup
                            name={path('serialNo', i)}
                            label="Serial No"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FormGroup
                            name={path(order?.isTradePrice ? 'prices.tradePrice' : 'prices.retailPrice', i)}
                            label="Price"
                            disabled
                          />
                        </div>
                        <div className="col">
                          <FormGroup
                            name={path('status', i)}
                            label="Status"
                            disabled
                          />
                        </div>
                      </div>

                      {consignment && (
                        <FormGroup
                          name={`items.${i}.remarks`}
                          label="Remarks"
                        />
                      )}
                    </>
                  )}
                </FieldArrayCards>
              </div>
            </div>
          </>
        )}
      </FieldArray>
    </>
  );
};

export default FieldsProductsList;
